import { useEffect, useState } from 'react';

import { AD_ENTITY_TYPES, HTTP_OPTIONS, INVESTIGATION_ENTITY_TYPES } from '@silverfort-nodelibs/common/utils/consts';

import Boxes from './Boxes';
import EntityCard from '../../../EntityCard/EntityCard';
import exportIcon from '../../../common/Images/export.png';
import { entityDataExport } from '../../InvestigationUtils';

import { ENTITY_TYPE_TO_DETAILS_OPTIONS } from '../../../EntityCard/EntityDetailsMapping';
import { httpGet } from '../../../utils';
import MultipleEntitiesCard from '../../../EntityCard/MultipleEntitiesCard';

const isMachineAccount = (entity) => {
    return entity?.type === AD_ENTITY_TYPES.SERVER;
};

const EntityData = ({
    isMultiple,
    entityGuid,
    displayName,
    entityType,
    setEntityId,
    user,
    minimizedView = false,
    showGoToInvestigation = false, // will only work in minimizedView
    customFieldsToShow = undefined,
    customDetailsClass = '',
    countInvolvedEntityClicked = false,
    entitiesData
}) => {
    const [currentEntityIndex, setCurrentEntityIndex] = useState(0);
    const [entityData, setEntityData] = useState({});
    const [detailsFields, setDetailsFields] = useState([]);

    useEffect(() => {
        if (customFieldsToShow) {
            setDetailsFields(customFieldsToShow);
        } else {
            if (ENTITY_TYPE_TO_DETAILS_OPTIONS[entityType?.id]) {
                setDetailsFields(ENTITY_TYPE_TO_DETAILS_OPTIONS[entityType.id]);
            }
        }
    }, [customFieldsToShow, entityType]);

    useEffect(() => {
        const getEntityData = async () => {
            const params = {
                entityGuid: isMultiple ? entitiesData[currentEntityIndex].guid : entityGuid,
                displayName: isMultiple ? entitiesData[currentEntityIndex].name : displayName,
                countInvolvedEntityClicked
            };

            const response = await httpGet(
                isMachineAccount(entitiesData?.[currentEntityIndex])
                    ? INVESTIGATION_ENTITY_TYPES.RESOURCE.urlData
                    : entityType.urlData,
                {
                    [HTTP_OPTIONS.REQ_OPTIONS]: { params: params },
                    [HTTP_OPTIONS.HANDLE_ERRORS]: true
                }
            );
            if (response.data) {
                const data = response.data;
                setEntityData(data);
                setEntityId &&
                    setEntityId(
                        entityType.id === INVESTIGATION_ENTITY_TYPES.USER.id
                            ? data.details.identifier || ''
                            : data.details.display_name.toLowerCase()
                    );
            }
        };
        getEntityData();

        return () => {
            setEntityData({});
        };
    }, [
        entityGuid,
        entityType,
        setEntityId,
        displayName,
        countInvolvedEntityClicked,
        currentEntityIndex,
        entitiesData,
        isMultiple
    ]);

    if (!minimizedView) {
        return (
            <div className="h-full grid grid-rows-[200px_80px] gap-2.5">
                <div className="relative h-full">
                    <button
                        className="bg-transparent absolute border-[none] right-2 top-2"
                        onClick={() => entityDataExport(entityData, entityType)}
                        title="Export">
                        <img className="mr-[5px]" src={exportIcon} alt="" />
                    </button>
                    {isMultiple ? (
                        <MultipleEntitiesCard
                            entityData={entityData}
                            entityType={entityType}
                            showBox={true}
                            showMemberships={true}
                            customFieldsToShow={detailsFields}
                            customDetailsClass={customDetailsClass}
                            setCurrentEntityIndex={setCurrentEntityIndex}
                            currentEntityIndex={currentEntityIndex}
                            entitiesData={entitiesData}
                        />
                    ) : (
                        <EntityCard
                            entityData={entityData}
                            entityType={entityType}
                            showBox={true}
                            showMemberships={true}
                            customFieldsToShow={detailsFields}
                            customDetailsClass={customDetailsClass}
                        />
                    )}
                </div>
                <Boxes entityData={entityData} entityType={entityType} user={user} />
            </div>
        );
    }

    return isMultiple ? (
        <MultipleEntitiesCard
            entityData={entityData}
            entityType={entityType}
            showBox={false}
            showMemberships={false}
            customFieldsToShow={detailsFields}
            customDetailsClass={customDetailsClass}
            setCurrentEntityIndex={setCurrentEntityIndex}
            currentEntityIndex={currentEntityIndex}
            showGoToInvestigation={showGoToInvestigation}
            entitiesData={entitiesData}
        />
    ) : (
        <EntityCard
            entityData={entityData}
            entityType={entityType}
            showBox={false}
            showMemberships={false}
            customFieldsToShow={detailsFields}
            customDetailsClass={customDetailsClass}
            showGoToInvestigation={showGoToInvestigation}
        />
    );
};

export default EntityData;
